import { useNavigate } from 'react-router-dom';

const useHistory = props => {
  let navigate = useNavigate();

  function goBack() {
    navigate(-1);
  }
  function push(url, options) {
    navigate(url, options);
  }
  function replace(url, options) {
    navigate(url, { ...(options || {}), replace: true });
  }
  function go(index) {
    navigate(index);
  }
  function reload() {
    navigate(0);
  }

  return { goBack, push, replace, go, reload };
};

export default useHistory;
